import { ListConfig } from 'components/List/types';

export const listConfig: ListConfig = {
  columns: [{ xs: 6 }, { container: true, justify: 'flex-end', xs: 6 }],
};
